import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from "vue";
import { useStore } from "vuex";

import GlobalLoading from "@/components/common/GlobalLoading.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const loading = computed(() => store.state.loading);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(GlobalLoading, null, null, 512), [
          [_vShow, _unref(loading)]
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})